import { render } from "./index.vue?vue&type=template&id=c57e8cda&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./style/index.scss?vue&type=style&index=0&id=c57e8cda&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=c57e8cda&scoped=true&lang=css"

import exportComponent from "D:\\chat-tx\\chat-example\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c57e8cda"]])

export default __exports__